/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { useSelector } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { NavLink, useParams } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Pagination from "@material-ui/lab/Pagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Badge from "components/Badge/Badge.js";

// @material-ui/icons
import SaveIcon from "@material-ui/icons/Save";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AddIcon from "@material-ui/icons/AddCircle";
import SearchIcon from "@material-ui/icons/Search";
import AlertIcon from "@material-ui/icons/AddAlert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DateRangeIcon from "@material-ui/icons/DateRange";
import CloseIcon from "@material-ui/icons/Close";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CustomInput from "components/CustomInput/CustomInput.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import Input from "@material-ui/core/Input";
import i18n from "components/Translation/Translate.js";
import Datetime from "react-datetime";

import { withNamespaces } from "react-i18next";
import { PostData } from "../../services/Request";
import * as Func from "services/Function";
import styles from "assets/jss/main-style.js";

/* ========== ZONE Variable ========== */
const useStyles = makeStyles(styles);

const initAttr = {
  code: "",
  filepic: "",
  product_code: "",
  product_id: "",
  product_name: "",
  branch_code: "",
  unit_code: "",
  unit_name: "",
  quantity: "",
};

const initFind = {
  search: "",
  date_start: Func.dateAdd(-30),
  date_stop: new Date(),
  order_by: "tb.id",
  order_sort: "desc",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

/* ========== ZONE Function ========== */
function AdjustStock({ t }) {
  const mod = "adjuststock";
  const prefix = "attr";
  const classes = useStyles();

  const initHeader = [
    { code: "image", name: `${mod}.image`, sort: false },
    { code: "tb.id", name: `${mod}.id`, order: "desc" },
    { code: "tb.branch_code", name: `${prefix}.branch` },
    { code: "pd.id", name: `${mod}.product_id` },
    { code: "pd.name_th", name: `${mod}.product_name` },
    { code: "tb.date_create", name: `${mod}.date` },
    { code: "em.name", name: `${mod}.employee` },
    { code: "tb.quantity", name: `${mod}.quantity` },
  ];
  const alignValue = [0, 1, 3, 4, 7, 8];
  const alignItem = [
    classes.center,
    classes.center,
    classes.center,
    classes.center,
    classes.right,
    classes.center,
  ];
  const cboPerPage = [
    { id: 10, name: "element.show_10_record" },
    { id: 20, name: "element.show_20_record" },
    { id: 100, name: "element.show_100_record" },
  ];

  const app = useSelector((state) => state.appState);
  const txtQuantity = useRef(null);
  const txtSearchList = useRef(null);
  const txtSearchBranch = useRef();
  const [searchList, setSearchList] = useState("");
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [header, setHeader] = useState(initHeader);
  const [alert, setAlert] = useState(null);
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cboBranch, setCboBranch] = useState([]);
  const [modalAdd, setModalAdd] = useState(false);
  const [order, setOrder] = useState([]);
  const [branch, setBranch] = useState("ALL");
  const [type, setType] = useState("+");

  useEffect(() => {
    i18n.changeLanguage(app.lang);
    init();
  }, [id]);

  const init = () => {
    PostData(mod, "init", {
      token: app.token,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        setCboBranch(result.branch);

        if (id === undefined) {
          view(find);
        } else if (id === "add") {
          setAttr(initAttr);
          searchOrder(branch);
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const view = (data) => {
    setLoading(true);
    PostData(mod, "view", {
      token: app.token,
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      asc: data.order_sort,
      start: Func.dateFormat(data.date_start),
      stop: Func.dateFormat(data.date_stop),
    }).then((result) => {
      if (result.status === "OK") {
        setRecord([]);

        result.data.map((item, i) => {
          setRecord((record) => [
            ...record,
            [
              <img src={item.image} width="30" />,
              item.id,
              item.branch_name,
              item.product_id,
              item.product_name,
              Func.dateTimeDisplay(item.date_create),
              item.emp_name,
              displayQuantity(item),
              item.unit_name,
            ],
          ]);
        });

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const displayQuantity = (item) => {
    return item.quantity < 0 ? (
      <span className={classes.colorDanger}>
        {Func.numberDisplay(item.quantity)}
      </span>
    ) : (
      <span className={classes.colorSuccess}>
        +{Func.numberDisplay(item.quantity)}
      </span>
    );
  };

  const searchOrder = (branch) => {
    const btnOrder = (item) => {
      return (
        <div>
          <Button
            round
            color="success"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => openProduct(item, "+")}
          >
            <AddIcon className={classes.icon} />
          </Button>
          <Button
            round
            color="danger"
            className={classes.actionButton + " " + classes.actionButtonRound}
            onClick={() => openProduct(item, "-")}
          >
            <RemoveCircleIcon className={classes.icon} />
          </Button>
        </div>
      );
    };

    PostData(mod, "searchproduct", {
      token: app.token,
      lang: app.lang,
      search: txtSearchList.current.value,
      branch: branch,
    }).then((result) => {
      if (result.status === "OK") {
        setOrder([]);

        result.data.map((item, i) => {
          setOrder((order) => [
            ...order,
            [
              <img src={item.filepic} width="30" />,
              item.product_id,
              item.product_name,
              item.branch_name,
              item.quantity,
              item.unit_name,
              btnOrder(item),
            ],
          ]);
        });
      }
    });
  };

  const openProduct = (item, ty) => {
    setType(ty);
    setAttr({
      ...attr,
      product_code: item.product_code,
      product_id: item.product_id,
      product_name: item.product_name,
      filepic: item.filepic,
      unit_code: item.unit_code,
      unit_name: item.unit_name,
      branch_code: item.branch_code,
      branch_name: item.branch_name,
      quantity: "",
    });
    setModalAdd(true);

    setTimeout(function () {
      txtQuantity.current.select();
    }, 500);
  };

  const checkEmpty = () => {
    let result = true;

    if (attr.quantity <= 0) {
      result = false;
    }

    return result;
  };

  const add = () => {
    if (!checkEmpty()) {
      showNotify(t("alert.pleaseinsert"), "danger");
    } else {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={t("alert.confirm_edit_title")}
          onConfirm={() => {
            setModalAdd(false);
            setAlert(null);
            setLoading(true);

            PostData(mod, "add", {
              data: {
                quantity: type === "+" ? attr.quantity : attr.quantity * -1,
                product_code: attr.product_code,
                unit_code: attr.unit_code,
                branch_code: attr.branch_code,
              },
            }).then((result) => {
              setLoading(false);
              if (result.status === "OK") {
                showNotify(t("alert.editcomplete"), "success");
                setAttr(initAttr);
                searchOrder(branch);
              } else {
                showNotify(t("alert.editerror"), "danger");
              }
            });
          }}
          onCancel={() => setAlert(null)}
          confirmBtnCssClass={classes.button + " " + classes.success}
          cancelBtnCssClass={classes.button + " " + classes.danger}
          confirmBtnText={t("alert.ok")}
          cancelBtnText={t("alert.cancel")}
          showCancel
        >
          {t("alert.confirm_edit_msg")}
        </SweetAlert>
      );
    }
  };

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        place="tr"
        color={color}
        icon={AlertIcon}
        message={msg}
        open={true}
        closeNotification={() => setNotify(null)}
        close
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const renderHeader = (data) => {
    let icon = <i className="fas fa-sort"></i>;
    if (data.order === "desc") {
      icon = <i className="fad fa-sort-up"></i>;
    } else if (data.order === "asc") {
      icon = <i className="fad fa-sort-down"></i>;
    } else {
      icon = <i className="fad fa-sort"></i>;
    }

    if (data.sort === undefined || data.sort)
      return (
        <div
          onClick={() => {
            let tmp = [];
            header.map((item, i) => {
              if (data.code === item.code) {
                const ordersort = item.order === "asc" ? "desc" : "asc";
                view({ ...find, order_sort: ordersort, order_by: data.code });
                setFind({
                  ...find,
                  order_sort: ordersort,
                  order_by: data.code,
                });
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: ordersort,
                  sort: item.sort,
                };
              } else {
                tmp[i] = {
                  code: item.code,
                  name: item.name,
                  order: "",
                  sort: item.sort,
                };
              }
            });

            setHeader(tmp);
          }}
          style={{ cursor: "pointer" }}
        >
          {t(data.name)} {icon}
        </div>
      );
    else return <div>{t(data.name)}</div>;
  };

  const renderViewList = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.viewlist")}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer className="viewlist">
                <GridItem xs={12} sm={6} md={6}>
                  <TextField
                    id="search"
                    fullWidth
                    InputProps={{
                      onChange: (e) => {
                        view({ ...find, search: e.target.value, page: 1 });
                        setFind({ ...find, search: e.target.value, page: 1 });
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          {t("element.search")} :
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      autoComplete: "off",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={6} md={3}></GridItem>
                <GridItem xs={12} sm={6} md={3}></GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Datetime
                      timeFormat={false}
                      dateFormat="DD/MM/yyyy"
                      closeOnSelect
                      value={find.date_start}
                      onChange={(value) => {
                        view({ ...find, date_start: value, page: 1 });
                        setFind({ ...find, date_start: value, page: 1 });
                      }}
                      className={classes.center}
                      renderInput={(props) => {
                        return (
                          <TextField
                            fullWidth
                            InputProps={{
                              ...props,
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{ marginBottom: "4px" }}
                                >
                                  {t("element.start")} :
                                </InputAdornment>
                              ),
                              endAdornment: <DateRangeIcon />,
                              autoComplete: "off",
                              readOnly: true,
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <Datetime
                      timeFormat={false}
                      dateFormat="DD/MM/yyyy"
                      closeOnSelect
                      value={find.date_stop}
                      onChange={(value) => {
                        view({ ...find, date_stop: value, page: 1 });
                        setFind({ ...find, date_stop: value, page: 1 });
                      }}
                      className={classes.center}
                      renderInput={(props) => {
                        return (
                          <TextField
                            fullWidth
                            InputProps={{
                              ...props,
                              startAdornment: (
                                <InputAdornment
                                  position="start"
                                  style={{ marginBottom: "4px" }}
                                >
                                  {t("element.stop")} :
                                </InputAdornment>
                              ),
                              endAdornment: <DateRangeIcon />,
                              autoComplete: "off",
                              readOnly: true,
                            }}
                          />
                        );
                      }}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12}>
                  <Table
                    striped
                    hover
                    tableHead={[
                      renderHeader(header[0]),
                      renderHeader(header[1]),
                      renderHeader(header[2]),
                      renderHeader(header[3]),
                      renderHeader(header[4]),
                      renderHeader(header[5]),
                      renderHeader(header[6]),
                      renderHeader(header[7]),
                      <NavLink to={`/admin/${mod}/add`}>
                        <Button
                          color="primary"
                          className={classes.actionButton}
                          block
                        >
                          {t(`element.add`)}
                          <AddIcon />
                        </Button>
                      </NavLink>,
                    ]}
                    tableData={record}
                    customHeadClassesForCells={alignValue}
                    customHeadCellClasses={alignItem}
                    customClassesForCells={alignValue}
                    customCellClasses={alignItem}
                    coloredColls={[]}
                    colorsColls={[]}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={3}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}></InputLabel>
                    <Select
                      value={find.perPage}
                      onChange={(e) => {
                        view({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                        setFind({
                          ...find,
                          page: 1,
                          perPage: e.target.value,
                          page: 1,
                        });
                      }}
                    >
                      {cboPerPage &&
                        cboPerPage.map((item) => (
                          <MenuItem
                            key={item.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={item.id}
                          >
                            {t(item.name)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem
                  xs={12}
                  sm={6}
                  md={8}
                  lg={9}
                  className={classes.right}
                >
                  <Pagination
                    style={{ float: "right", marginTop: "20px" }}
                    count={pageTotal}
                    showFirstButton
                    showLastButton
                    page={pageNo}
                    onChange={(e, p) => {
                      view({ ...find, page: p });
                      setFind({ ...find, page: p });
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderAdd = () => {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody className={classes.right}>
              <NavLink to={`/admin/${mod}`}>
                <Button color="warning">
                  <ArrowBackIcon /> {t("element.back")}
                </Button>
              </NavLink>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <AssignmentIcon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{t("element.adddata")}</h4>
            </CardHeader>
            <CardBody>{renderInfo()}</CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  };

  const renderInfo = () => {
    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={4}>
          <FormControl fullWidth className={classes.selectFormControl}>
            <InputLabel htmlFor="branch" className={classes.labelSelect}>
              {t(`${mod}.branch`)}
            </InputLabel>
            <Select
              ref={txtSearchBranch}
              MenuProps={{
                className: classes.selectMenu,
              }}
              classes={{
                select: classes.select,
              }}
              value={branch}
              inputProps={{
                // inputRef: txtSearchBranch,
                name: "branch",
              }}
              onChange={(e) => {
                setBranch(e.target.value);
                setOrder([]);
                searchOrder(e.target.value);
              }}
            >
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
                value="ALL"
              >
                {t(`${mod}.all`)}
              </MenuItem>
              {cboBranch.map((item) => (
                <MenuItem
                  key={item.code}
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={item.code}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={6} md={8}>
          <form
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              searchOrder(branch);
            }}
          >
            <CustomInput
              labelText={t("element.search")}
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                inputRef: txtSearchList,
              }}
            />
          </form>
        </GridItem>
        <GridItem xs={12}>
          <Table
            striped
            hover
            tableHead={[
              t(`${mod}.image`),
              t(`${mod}.product_id`),
              t(`${mod}.product_name`),
              t(`${mod}.branch`),
              t(`${mod}.quantity`),
              t(`${mod}.unit`),
              "",
            ]}
            tableData={order}
            customHeadClassesForCells={[4, 6]}
            customHeadCellClasses={[classes.right, classes.right]}
            customClassesForCells={[4, 6]}
            customCellClasses={[classes.right, classes.right]}
            coloredColls={[4]}
            colorsColls={["primary"]}
          />
        </GridItem>
      </GridContainer>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderModalAdd = () => {
    return (
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={modalAdd}
        maxWidth={"lg"}
        fullWidth
        keepMounted
        onClose={() => setModalAdd(false)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="modal-add-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setModalAdd(false)}
          >
            <CloseIcon className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <span>{attr.branch_name} </span>
            {type === "+" ? (
              <Badge color="success">{t("element.add")}</Badge>
            ) : (
              <Badge color="danger">{t("element.sub")}</Badge>
            )}
          </h4>
        </DialogTitle>
        <DialogContent id="modal-add" className={classes.modalBody}>
          <br />
          <form autoComplete="off">
            <GridContainer>
              <GridItem xs={12} sm={4}>
                <img src={attr.filepic} width="100%" />
              </GridItem>
              <GridItem xs={12} sm={8}>
                <CustomInput
                  labelText={t(`${mod}.product_id`)}
                  id="product_id"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: attr.product_id,
                    disabled: true,
                  }}
                />
                <CustomInput
                  labelText={t(`${mod}.product_name`)}
                  id="product_name"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: attr.product_name,
                    disabled: true,
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <p></p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <Table
                  striped
                  hover
                  tableData={[
                    [
                      <b>
                        {t(`${mod}.quantity`)} [{attr.unit_name}]
                      </b>,
                      <Input
                        inputRef={txtQuantity}
                        id="quantity"
                        placeholder="0.00"
                        inputProps={{
                          "aria-label": "quantity",
                          value: attr.quantity,
                          type: "number",
                        }}
                        classes={{
                          input: classes.right,
                        }}
                        color="primary"
                        fullWidth={false}
                        onChange={(e) =>
                          setAttr({ ...attr, quantity: e.target.value })
                        }
                      />,
                    ],
                  ]}
                  customHeadClassesForCells={[1]}
                  customHeadCellClasses={[classes.right]}
                  customClassesForCells={[1]}
                  customCellClasses={[classes.right]}
                  coloredColls={[]}
                  colorsColls={[]}
                />
              </GridItem>
            </GridContainer>
          </form>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button onClick={add} color="success">
            <SaveIcon /> {t(`element.save`)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderPage = () => {
    if (id === undefined) {
      return renderViewList();
    } else if (id === "add") {
      return renderAdd();
    }
  };

  /* ========== ZONE Render ========== */
  return (
    <div>
      {renderPage()}
      {renderModalAdd()}
      {renderLoading()}
      {alert}
      {notify}
    </div>
  );
}

export default withNamespaces()(AdjustStock);
